import { ActivityType } from '@/types';
import { calculateUnifiedRewards, getAccountabilityMessage } from '@/lib/unifiedPointSystem';

export const logActivityHelper = (activityType: ActivityType, isEnhanced = false) => {
  const rewards = calculateUnifiedRewards(activityType, false);
  
  if (import.meta.env.DEV) {
    console.log(`🎯 ${isEnhanced ? 'Enhanced' : 'Direct'} activity logging (accountability system):`, {
      activity: activityType.name,
      pointsOnly: rewards.points,
      missedXP: activityType.points * 2,
      missedGold: Math.floor(activityType.points / 2),
      accountabilityMessage: getAccountabilityMessage(activityType)
    });
  }
  
  return rewards;
};

export const formatLocationForLog = (locationData: any): string => {
  if (!locationData) return 'None';
  if (locationData.latitude !== 0 && locationData.longitude !== 0) {
    return `${locationData.latitude}, ${locationData.longitude}`;
  }
  return 'Manual location';
};
